import React from "react";
const Footer = () => {
	var d = new Date();
	return (
		<div className="footer">
			<div className="copyright">
				<p>Copyright © Designed &amp; Developed by{" "}
					<a href="https://stashtechnologies.com/" target="_blank"  rel="noreferrer">
						Stash Technologies
					</a>{" "}
					2025
				</p>
			</div>
		</div>
	);
};

export default Footer;
